const Resources = {

    table_headers: [
        { 
          text: 'Description',
          align: 'start',
          value: 'description'
        },
        { 
            text: 'Shift',
            value: 'shift'
        },
        {   
            text: 'Number',
            value: 'number'
        },
        { 
            text: 'Break time',
            value: 'formatted_time'
        },
        { 
            text: 'Length',
            value: 'length'
        },
        {   
            text: 'Paid',
            value: 'paid',
            type: 'boolean',
        },
    ],

    breadcrumb:[
        {
            name:   'Home',
            href:   '/',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Assignments',
            href:   '/assignment-daily-assignments',
            arrow:  "<span class='slash'>/</span>",
        },
        {
            name:   'Breaks',
            href:   '/breaks',
            arrow:  "",
        },
        // {
        //     name:   'Breaks',
        //     href:   '#',
        //     arrow:  "<span class='slash'>/</span>",
        // },
    ],

    excel_file_headers: {
        'Break #': 'number',
        'Shift':   'shift_name',
        'Description': 'description',
        'Break time': 'time',
        'Length': 'length',
        'Paid (True o False)': 'paid',
    },

    empty_format_data: [
        {
            shift_name:     '',
            number:         '',
            description:    '',
            time:           '',
            length:         0,
            paid:           false,
        },
    ],

    excel_fields_required: {
        number:         true,
        description:    true,
        time:           true,
        length:         true,
        paid:           false,
    },

    helps: [
        {
            label: '¿How to add a Break?', 
            instruction: `https://scribehow.com/embed/How_To_Add_A_Break__n9uHuNBMSv6wUOHmrrfBpA?as=scrollable`
        },
        {
            label: '¿How to delete Breaks?', 
            instruction: `https://scribehow.com/embed/How_To_Delete_Breaks__B6ZTucWUQ8uCpET9OZ0Xtg?as=scrollable`
        },
    ],

}

export default Resources;